/**
 * Poll transformation utilities
 * Converts between API poll formats and UI component formats
 */ /**
 * API의 Poll 응답을 ContentBase 컴포넌트가 사용하는 형식으로 변환
 */ export var transformApiPollToContentPoll = function(apiPoll, onVote) {
    if (!apiPoll) return null;
    return {
        question: apiPoll.question || apiPoll.pollId || '투표',
        options: Array.isArray(apiPoll.options) ? apiPoll.options.map(function(opt) {
            return {
                id: opt.optionId,
                text: opt.text,
                votes: opt.votes
            };
        }) : [],
        totalVotes: apiPoll.totalVotes || 0,
        expiresAt: apiPoll.expiresAt ? new Date(apiPoll.expiresAt) : undefined,
        userVoted: apiPoll.userVotedOptionId,
        // 추가 정보 전달
        pollId: apiPoll.pollId,
        durationMinutes: apiPoll.durationMinutes,
        isExpired: apiPoll.isExpired,
        votingStatus: apiPoll.isExpired ? 'CLOSED' : apiPoll.userVotedOptionId ? 'VOTED' : 'NOT_VOTED',
        onVote: onVote // onVote 핸들러 추가
    };
};
/**
 * ContentBase의 poll 데이터를 API 요청 형식으로 변환
 */ export var transformPollVoteToApiRequest = function(optionId) {
    return {
        optionId: optionId
    };
};
